import Vue from 'vue';
import store from './store'
import querystring from 'query-string';
import moment from 'moment'

export default new Vue({
    store,
    data () {
        return {
            API_TEST : 'https://api.stapmedif.besoin.dev/index.php/'
            // API_TEST : 'https://api.intra-stapmedif.fr/index.php/'
        }
    },
    methods : {
        api (url:string) {

            if(!url){
                url = "";
            }

            return this.API_TEST+url;
        },
        parseError (error:any){
            console.log(error)
            if(!error){
                return "Erreur interne";
            }
            let content = error.response.data;
            if(!content.message){
                return "Erreur sur serveur";
            }
            if(!content.code){
                return "Erreur inconnue";
            }
            switch(content.code){
                case 99 :
                    let message = "<ul>";
                    for (let [key, value] of Object.entries(content.message)) {
                        message += "<li>"+value+"</li>";
                    }
                    message += "</ul>";
                    return message;
                break;
            }

            return content.code;
        },
        toPOST(data:any){
            return querystring.stringify(data, {arrayFormat: 'bracket'});
        },
        headerPOST(){
            let headers = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': "Bearer "+this.$store.getters.getToken,
                }
            };

            if(!this.$store.getters.isAuthenticated){
                delete  headers.headers.Authorization;
            }

            return headers;
        },
        headerGET(){
            let headers = {
                headers : {
                    'Authorization': "Bearer "+this.$store.getters.getToken,
                }
            };

            if(!this.$store.getters.isAuthenticated){
                delete  headers.headers.Authorization;
            }

            return headers;
        },
        isSuccessResponse(response:any){

            return response.data.success === 1;
        },
        popup(type:string,data:any){

            if(!data.success)
                data.success = function(){};
            if(!data.successSecond)
                data.successSecond = function(){};
            if(!data.error)
                data.error = function(){};

            switch(type){
                case "valid":
                    this.$emit("popupValid",data.title,data.message,data.success);
                    break;
                case "confirm" :
                    this.$emit("popupConfirm",data.title || "Confirmation",data.message || "Attention l'action que vous allez faire est iréversible. Voulez-vous continuer ?",data.btn || ["Confirmer","Non"],data.success,data.error,data.successSecond);
                    break;
            }
        },
        setLocals(name:string,obj:any){

            if(!localStorage[name] || localStorage[name] === "false"){
                return false;
            }

            let param = JSON.parse(localStorage[name]);

            for (let [key, value] of Object.entries(param)) {

                let val = value;
                if(val === null){
                    val = obj.$data[key];
                }

                obj[key] = val;
            }

            return true;
        },
        saveLocals(name:string,obj:any){

            let param = {};
            let locals = obj.$data.locals;

            if(!locals){
                return;
            }

            for (let [key, value] of Object.entries(obj.$data)) {

                if(locals.indexOf(key) < 0){
                    continue;
                }

                param[key] = value;

            }

            localStorage[name] = JSON.stringify(param);

        },
        saveAllLocals(name:string,data:any){

            let param = {}

            for (let [key, value] of Object.entries(data)) {
                param[key] = value
            }

            this.saveLocals(name,param);
        },
        removeLocal(name:string){
            localStorage[name] = "";
        },
        resetLocals(){

            for (let [key, value] of Object.entries(localStorage)) {

                localStorage[key] = false
            }
        },
        saveCookies(name:string,obj:any){

            let param = {};
            let locals = obj.$data.cookies;

            if(!locals){
                return;
            }

            for (let [key, value] of Object.entries(obj.$data)) {

                if(locals.indexOf(key) < 0){
                    continue;
                }

                param[key] = value;

            }

            Vue.$cookies.set(name,param);

        },
        setCookies(name:string,obj:any){

            let param = Vue.$cookies.get(name);

            if(!param){
                return false;
            }

            for (let [key, value] of Object.entries(param)) {

                let val = value;
                if(val === null){
                    val = obj.$data[key];
                }

                obj[key] = val;
            }
        },
        loader(active:boolean){
            this.$emit("loader",active)
        },
        sortArray(array:any,order:any) {
            if (order) {
                array.sort((obj1:any, obj2:any) => {

                    let data1 = obj1;
                    let data2 = obj2;
                    if(order.name.match(/\./)){
                        let names = order.name.split('.');
                        for(let i=0;i<names.length;i++){
                            data1 = data1[names[i]];
                            data2 = data2[names[i]];

                        }
                    }else{
                        data1 = obj1[order.name];
                        data2 = obj2[order.name];
                    }

                    if(!data1){data1 = ""};
                    if(!data2){data1 = ""};

                    if (data1 < data2) {
                        return order.order === 'asc' ? -1 : 1;
                    } else if (data1 > data2) {
                        return order.order === 'asc' ? 1 : -1;
                    }
                    return 0;
                })
            }
        },
        editLimit(call:any){

            if(this.$store.getters.hasPerm('call:edit')){
                return true;
            }

            if(!this.$store.getters.hasPerm('call:edit:limit')){
                return false;
            }

            let dateHour = moment(String(call.date_validation+" "+call.hour_validation),"YYYY-MM-DD HH:mm:ss");
            let now = moment();

            let diff = moment(now).diff(dateHour);
            let delay = moment.duration(diff);

            if(delay.asMinutes() > 10){
                return false;
            }

            return true;


        },
        nl2br(text:string){
            if(!text){
                return "";
            }
            return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
        },
        toByte(size){

            let value = "Ko";
            size = (size / 1024).toFixed(2);

            if(size > 1024){
                size = (size / 1024).toFixed(2);
                value = "Mo";

                if(size > 1024){
                    size = (size / 1024).toFixed(2);
                    value = "Go"
                }
            }

            return size+value;
        }
    }

})